<template>
  <div class="misc-layout">
    <div class="misc-layout-content">
      <img src="@/assets/img/404.png" alt="graphic-404" />
      <h1 class="my-5">Seite nicht gefunden</h1>
      <p>
        Diese Seite haben wir leider nicht gefunden. Suchen Sie eine "Themen im
        Fokus" Seite? <br />Dann finden Sie die Übersicht
        <a href="https://dsagnet.de/content/themen-im-fokus-ubersicht"
          ><b>hier</b></a
        >. <br /><br />Suchen Sie Veranstaltungen, Gremien, Dateien oder
        Mitglieder, dann nutzen Sie bitte unsere Suchfunktion.
      </p>
      <b-button
        variant="orange"
        :to="{ name: 'global-search' }"
        class="icon-right"
      >
        Jetzt suchen <i class="fa-light fa-magnifying-glass"></i
      ></b-button>
    </div>
  </div>
</template>

<script>
export default {
  title: "DSAGNet - Nicht gefunden",
};
</script>

<style lang="scss" scoped>
.misc-layout {
  background-image: url(@/assets/img/bg.jpg);
  height: calc(100vh - 158px);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  &-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
</style>
